import { LegalEntityAuditApiModel } from "../../../../legalEntity/legalEntityAuditTab/LegalEntityAudit.types";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export interface ISystemAuditsHooksProps {
    systemId: string;
}

export default function useSystemAudits(props: ISystemAuditsHooksProps) {
    const externalAuditsUrl = `/SystemOverview/${props.systemId}/audits`;
    const {
        isLoading: isLoadingExternalAudits,
        data: externalAudits,
        refetch: refetchExternalAudits,
    } = useDotLegalQuery<Array<LegalEntityAuditApiModel>>(externalAuditsUrl);

    return {
        externalAudits,
        isLoadingExternalAudits,
        refetchExternalAudits,
    };
}
